import { union } from '@ngrx/store';

import { GlobalActions } from '@fcom/core/actions';
import { updateStoreAction } from '@fcom/core/store/init-store.action';
import { setIn } from '@fcom/utils';
import { CartActions } from '@fcom/booking/store/actions';

import { PaymentState, PaymentStatus } from '../../interfaces';
import { PaymentActions } from '../actions';

export const initialState: PaymentState = Object.seal({ paymentStatus: PaymentStatus.INITIAL, redirectionUrl: null });

type PaymentStateKey<T> = T extends keyof PaymentState ? T : never;

const PAYMENT_STATUS: PaymentStateKey<'paymentStatus'> = 'paymentStatus'; // Persisted
const PAYMENT_REDIRECTIONURL: keyof PaymentState = 'redirectionUrl'; // Persisted

const all = union({
  updateStoreAction,
  paymentVerified: GlobalActions.paymentVerified,
  paymentNotPaid: GlobalActions.paymentNotPaid,
  setCartData: CartActions.setCartData,
});

type ExtraActions = typeof all;

export function paymentReducer(state = initialState, action: PaymentActions.ActionsUnion | ExtraActions): PaymentState {
  switch (action.type) {
    case PaymentActions.setPaymentStatus.type:
      return setIn(state, PAYMENT_STATUS, action.status);

    case PaymentActions.setPaymentRedirectionUrl.type:
      return setIn(state, PAYMENT_REDIRECTIONURL, action.url);

    case updateStoreAction.type:
    case CartActions.setCartData.type:
      return initialState;

    case GlobalActions.paymentVerified.type:
      return setIn(state, PAYMENT_STATUS, PaymentStatus.VERIFIED);

    case GlobalActions.paymentNotPaid.type:
      return setIn(state, PAYMENT_STATUS, PaymentStatus.INITIAL);

    default:
      return initialState;
  }
}
